import { api } from "../../../app/conf";
import Repository from "../../repository/Repository";

export default class UserService {
  #endpoint;
  #repository;

  constructor() {
    this.#endpoint = `${api}/v1/users`;
    this.#repository = new Repository();
  }

  async deleteUser(deleteUserParams) {
    try {
      const { token, signal, userId, userIdToSetCases } = deleteUserParams;

      const endpoint = `${this.#endpoint}/${userId}`;

      const params = {
        userIdToSetCases
      };

      const data = await this.#repository.delete({
        endpoint,
        token,
        signal,
        params
      });

      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getUsers(getUsersParams) {
    try {
      const { token, signal, filters } = getUsersParams;

      const endpoint = `${this.#endpoint}`;

      const params = {
        ...filters
      };

      const data = await this.#repository.get({
        endpoint,
        token,
        signal,
        params
      });

      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
